import { useMemo, createElement } from 'react';

import { TitleLevel } from 'types';
import { Flex } from 'components/flex';
import { formatPrice } from 'utils/helpers';

import * as Styles from './styles';
import { CardProps, AdjustmentCardProps } from './types';

export const Card = ({
  name,
  isRed,
  value,
  titleLevel = TitleLevel.P,
}: CardProps) => (
  <Flex gap={16} justifyContent="space-between">
    {createElement(titleLevel, { children: name })}
    <Styles.Text isRed={isRed} isBold={titleLevel !== TitleLevel.P}>
      {formatPrice(isRed ? `-${Math.abs(value)}` : value)}
    </Styles.Text>
  </Flex>
);

export const AdjustmentCard = ({
  name,
  value,
  adjustments,
  currentEventName,
}: AdjustmentCardProps) => {
  const currentEventAmount = useMemo(() => {
    if (!adjustments?.length) {
      return 0;
    }

    const otherEventsTotal = adjustments.reduce(
      (sum, adj) => sum + Math.abs(adj.amount),
      0
    );

    const currentEventAmount = parseFloat(
      (Math.abs(value) - otherEventsTotal).toFixed(2)
    );

    return currentEventAmount;
  }, [adjustments, value]);

  if (!adjustments?.length) {
    return <Card isRed name={name} value={value} />;
  }

  return (
    <Flex fullWidth flexDirection="column">
      <Card isRed name={name} value={value} />
      {adjustments.map((adj, index) => (
        <Flex gap={8} key={index}>
          <Styles.Text isRed className="caption-regular">
            {adj.eventName}: {formatPrice(`-${Math.abs(adj.amount)}`)}
          </Styles.Text>
        </Flex>
      ))}

      {currentEventAmount > 0 && currentEventName && (
        <Flex gap={8}>
          <Styles.Text isRed className="caption-regular">
            {currentEventName}:{' '}
            {formatPrice(`-${currentEventAmount.toFixed(2)}`)}
          </Styles.Text>
        </Flex>
      )}
    </Flex>
  );
};
